import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Avatar from 'components/common/Avatar';
import FalconLightBoxGallery from 'components/common/FalconLightBoxGallery';
import Flex from 'components/common/Flex';
import { ChatContext } from 'context/Context';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import { Button, Col, Collapse, Dropdown, Form, Row } from 'react-bootstrap';
import SimpleBarReact from 'simplebar-react';
import { informacion } from 'sites/admin/inmobiliario/gestionarPropiedades/propertyWizard/steps/data/props';
import { FindedMessages } from './FindedMessages';
import SharedCardProp from 'sites/admin/inmobiliario/gestionarPropiedades/tables/propertiesTable/components/SharedCard';
import SharedCardProj from 'sites/admin/inmobiliario/projects/tables/components/SharedCard';

const ThreadInfo = ({ conversation }) => {
  const { isOpenConversationInfo, neighborhoodsObj } = useContext(ChatContext);

  const [isOpenSharedMediaCollapse, setIsOpenSharedMediaCollapse] =
    useState(false);
  const [isOpenPropertyCollapse, setIsOpenPropertyCollapse] = useState(true);

  const [search, setSearch] = useState('');
  const [findedMessages, setFindedMessages] = useState([]);

  const { client: user, property: prop, project: proj } = conversation;

  const handleSearchMessage = e => {
    const value = e.target.value;

    setSearch(value);
  };

  useEffect(() => {
    if (search) {
      const results = conversation.messages.filter(message => {
        return message.message.toLowerCase().includes(search.toLowerCase());
      });

      setFindedMessages(results);
    } else {
      setFindedMessages([]);
    }
  }, [search]);

  const handleAvatarUrl = () => {
    if (user.photo) {
      return user.photo.match(/http/)
        ? user.photo
        : `${process.env.REACT_APP_CLIENT}/uploads/clients/profile-pictures/${user.photo}`;
    }
  };

  return (
    <div
      className={classNames('conversation-info', {
        show: isOpenConversationInfo
      })}
    >
      <div className="h-100 overflow-auto">
        <SimpleBarReact style={{ height: '100%', overflowX: 'auto' }}>
          <div
            className="d-flex flex-column justify-content-between"
            style={{ minHeight: 'calc(100vh - 186px)' }}
          >
            <div>
              <Flex
                alignItems="center"
                className="position-relative p-3 hover-actions-trigger"
              >
                <Avatar
                  className={user.status}
                  size="xl"
                  src={handleAvatarUrl()}
                />

                <Flex className="ms-2 flex-between-center flex-1">
                  <div>
                    <h6 className="mb-0 text-800">
                      {user.firstName} {user.lastName}
                    </h6>
                    <p className="m-0 text-700">{user.email}</p>
                  </div>

                  <Dropdown className="z-index-1">
                    <Dropdown.Toggle
                      id="dropdown-button"
                      className="text-400 dropdown-caret-none me-n3 d-none"
                      variant="link"
                      size="sm"
                    >
                      <FontAwesomeIcon icon="cog" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="py-2 border bg-white">
                      <Dropdown.Item className="cursor-pointer text-danger">
                        Eliminar
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Flex>
              </Flex>

              <Form.Group className="mb-0 position-relative d-block w-100 h-100 px-3">
                <Form.Control
                  style={{ boxShadow: 'none' }}
                  className="chat-contacts-search border-0 h-100 ps-4"
                  placeholder="Buscar mensajes..."
                  size="sm"
                  onChange={handleSearchMessage}
                />

                <FontAwesomeIcon
                  icon="search"
                  className="position-absolute ps-2"
                  style={{
                    top: '50%',
                    transform: 'translate(0, -50%)'
                  }}
                />
                <hr className="mb-2 mt-0" />
              </Form.Group>

              {search ? (
                findedMessages.length > 0 ? (
                  <FindedMessages messages={findedMessages} search={search} />
                ) : (
                  <div className="text-center my-4">
                    No se encontraron mensajes.
                  </div>
                )
              ) : null}
              {!!conversation.images?.length && (
                <div>
                  <hr className="my-2" />

                  <div className="px-3">
                    <div className="title">
                      <Button
                        variant="link"
                        className="btn-accordion hover-text-decoration-none dropdown-indicator w-100"
                        aria-expanded={isOpenSharedMediaCollapse}
                        onClick={() =>
                          setIsOpenSharedMediaCollapse(
                            !isOpenSharedMediaCollapse
                          )
                        }
                      >
                        Archivos compartidos
                      </Button>

                      <Collapse in={isOpenSharedMediaCollapse}>
                        <div className="mt-2">
                          <FalconLightBoxGallery images={conversation.images}>
                            {setImgIndex => (
                              <Row className="mx-n1">
                                {conversation.images.map((image, index) => (
                                  <Col
                                    sm={6}
                                    md={4}
                                    className="px-1"
                                    key={index}
                                  >
                                    <img
                                      src={image}
                                      alt=""
                                      className="img-fluid rounded mb-2 cursor-pointer "
                                      onClick={() => {
                                        setImgIndex(index);
                                      }}
                                    />
                                  </Col>
                                ))}
                              </Row>
                            )}
                          </FalconLightBoxGallery>
                        </div>
                      </Collapse>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {prop && (
              <div>
                <hr className="m-0" />
                <div className="p-2">
                  <div className="title">
                    <Button
                      variant="link"
                      className="btn-accordion hover-text-decoration-none dropdown-indicator w-100 p-0"
                      aria-expanded={!isOpenPropertyCollapse}
                      onClick={() => setIsOpenPropertyCollapse(prev => !prev)}
                    >
                      Detalles de la propiedad
                    </Button>

                    <Collapse in={isOpenPropertyCollapse}>
                      <div className="mt-2">
                        <h6 className="fw-normal">
                          Sucursal:{' '}
                          <strong>
                            {conversation.branchOffice.branch_office_name}
                          </strong>
                        </h6>

                        <SharedCardProp
                          noShareModal
                          noShareButton
                          noRounded
                          noSharedPercent
                          noShadow
                          prop={{
                            id: prop._id,
                            title: prop.title,
                            images: prop.images,
                            address: `${prop.location.street} ${prop.location.number}`,
                            barrios:
                              neighborhoodsObj[prop.location.barrios?.at(-1)],
                            price: `${
                              prop.price?.total
                                ? informacion.currency[prop.price.currency]
                                : ''
                            } ${
                              prop.price?.total?.toLocaleString('en-US') ||
                              'Sin precio asignado'
                            }`,
                            expenses: `${
                              prop.price?.expenses
                                ? informacion.currency[
                                    prop.price.expensesCurrency
                                  ]
                                : ''
                            } ${
                              prop.price?.expenses?.toLocaleString('en-US') ||
                              'Sin expensas'
                            }`,
                            operation: `${
                              informacion.operation[prop.operation_type]
                            }`,
                            updated_at: dayjs(prop.updated_at).format(
                              'DD/MM/YYYY HH:mm [hs]'
                            ),
                            created_at: dayjs(prop.updated_at).format(
                              'DD/MM/YYYY HH:mm [hs]'
                            ),
                            type: informacion.property[prop.property_type],
                            share: prop.share,
                            locality: prop.location.locality,
                            characteristics: prop.characteristics,
                            surface: prop.surface
                          }}
                        />
                      </div>
                    </Collapse>
                  </div>
                </div>
              </div>
            )}

            {proj && (
              <div>
                <hr className="m-0" />
                <div className="p-2">
                  <div className="title">
                    <Button
                      variant="link"
                      className="btn-accordion hover-text-decoration-none dropdown-indicator w-100 p-0"
                      aria-expanded={!isOpenPropertyCollapse}
                      onClick={() => setIsOpenPropertyCollapse(prev => !prev)}
                    >
                      Detalles del emprendimiento
                    </Button>

                    <Collapse in={isOpenPropertyCollapse}>
                      <div className="mt-2">
                        <h6 className="fw-normal">
                          Sucursal:{' '}
                          <strong>
                            {conversation.branchOffice.branch_office_name}
                          </strong>
                        </h6>

                        <SharedCardProj
                          noShareModal
                          noShareButton
                          noRounded
                          noSharedPercent
                          noShadow
                          proj={{
                            id: proj._id,
                            title: proj.title,
                            images: proj.images,
                            address: `${proj.location.street} ${proj.location.number}`,
                            barrios:
                              neighborhoodsObj[proj.location.barrios?.at(-1)],
                            operation: `${
                              informacion.operation[proj.operation_type]
                            }`,
                            updated_at: dayjs(proj.updated_at).format(
                              'DD/MM/YYYY HH:mm [hs]'
                            ),
                            created_at: dayjs(proj.updated_at).format(
                              'DD/MM/YYYY HH:mm [hs]'
                            ),
                            type: informacion.property[proj.property_type],
                            share: proj.share,
                            locality: proj.location.locality,
                            units: proj.units,
                            real_estate: proj.real_estate,
                            info: proj.info
                          }}
                        />
                      </div>
                    </Collapse>
                  </div>
                </div>
              </div>
            )}
          </div>
        </SimpleBarReact>
      </div>
    </div>
  );
};

ThreadInfo.propTypes = {
  conversation: PropTypes.object.isRequired
};

export default ThreadInfo;
